module.exports = __webpack_public_path__ + "static/media/viewBtn.6f6aed7f.svg";